import { render } from "./ImpersonateLogin.vue?vue&type=template&id=aa05d8f4"
import script from "./ImpersonateLogin.vue?vue&type=script&lang=js"
export * from "./ImpersonateLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__